import { RealityCheckDataItem } from ".";

export class RealityCheckDto {
	casinoInfo: RealityCheckDataItem;
	casinoLiveInfo: RealityCheckDataItem;
	sportBettingInfo?: RealityCheckDataItem;
	sportBettingOnlineInfo?: RealityCheckDataItem;
	timePlayed: number;
}
